<template>
  <div v-if="product">
    <p class="text-center">
      <b>{{ product.name }}</b> - {{ $t('messages.giftVoucherRecipientInfo') }}
    </p>
    <VeeForm @submit="confirm" class="gift-voucher-form">
      <div class="form-group">
        <label>{{ $t('words.recipientName') }}*</label>
        <VeeField
          v-model="formData.firstName"
          name="firstName"
          type="text"
          class="form-control"
          :placeholder="$t('words.recipientName')"
          rules="required"
        />
        <ErrorMessage name="firstName" class="error-message" />
      </div>

      <div class="form-group">
        <label>{{ $t('words.recipientSurname') }}*</label>
        <VeeField
          v-model="formData.lastName"
          name="lastName"
          type="text"
          class="form-control"
          :placeholder="$t('words.recipientSurname')"
          rules="required"
        />
        <ErrorMessage name="lastName" class="error-message" />
      </div>

      <div class="form-group">
        <label>{{ $t('words.recipientEmail') }}*</label>
        <VeeField
          v-model="formData.email"
          name="email"
          type="email"
          class="form-control"
          :placeholder="$t('words.recipientEmail')"
          rules="required|email"
        />
        <ErrorMessage name="email" class="error-message" />
      </div>

      <div class="form-group">
        <label>{{ $t('words.recipientPhone') }}*</label>
        <VeeField
          v-model="formData.phone"
          name="phone"
          type="tel"
          class="form-control"
          :placeholder="$t('words.recipientPhone')"
          rules="required|phone"
        />
        <ErrorMessage name="phone" class="error-message" />
      </div>

      <div class="text-center button-group">
        <button @click="cancel()" type="button" class="secondary">{{ $t('actions.cancel') }}</button>
        <button type="submit" class="primary">{{ $t('actions.addToBasket') }}</button>
      </div>
    </VeeForm>
  </div>
</template>

<script>
import { defineRule } from "vee-validate";
import { Form as VeeForm, Field as VeeField, ErrorMessage } from "vee-validate";
import { i18n } from "@/lang";
import { validatePhoneNumber, getPhoneValidationMessage } from "@/utils/phoneValidation";

// Definir reglas de validación
defineRule('required', (value) => {
  if (value === null || value === undefined || value === false || (typeof value === 'string' && !value.trim().length) || (Array.isArray(value) && !value.length)) {
    return i18n.global.t('forms.required');
  }
  return true;
});

defineRule('email', (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return i18n.global.t('forms.email');
  }
  return true;
});

defineRule('phone', (value) => {
  if (!value || !value.length) {
    return true;
  }
  if (!validatePhoneNumber(value)) {
    return getPhoneValidationMessage(i18n, value);
  }
  return true;
});

export default {
  components: { VeeForm, VeeField, ErrorMessage },
  props: {
    product: { type: Object, required: true }
  },
  data () {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      }
    }
  },
  methods: {
    cancel () {
      this.reset()
      this.$emit('cancel')
    },
    confirm () {
      // El formulario ya fue validado por VeeValidate antes de llegar aquí
      const recipientData = { ...this.formData }
      this.$emit('recipient-selected', recipientData)
      this.reset()
    },
    reset () {
      this.formData = {
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      }
    }
  }
}
</script>

<style scoped>
.gift-voucher-form {
  max-width: 500px;
  margin: 20px auto;
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #464958;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #dedede;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #c91919;
}

.error-message {
  color: #c91919;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}

button {
  padding: 10px 30px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.3s;
}

button.primary {
  background-color: #c91919;
  color: white;
}

button.secondary {
  background-color: #939393;
  color: white;
}

button:hover {
  opacity: 0.8;
}

.text-center {
  text-align: center;
}

.text-center b {
  color: #464958;
  font-size: 1.1rem;
}
</style>

